import BaseModel from "./BaseModel"

export default class OwnerModel extends BaseModel {
    get schema() {
        return {
            percentage: "",
            is_legal_person: null,
            legal_person_name: "",
            legal_person_inn: "",
            legal_person_kpp: "",
            legal_person_ogrn: "",
            legal_person_location: "",
            legal_general_director: "",
            legal_phone: "",
            surname: "",
            name: "",
            patronymic: "",
            inn: "",
            snils: "", // 13849173290
            phone: "",
            document_type: "",
            document_seria: "",
            document_number: "",
            document_issued_at: null,
            document_subdivision_code: "",
            document_issued_by: "",
            document_reg_address: "",
            document_other_data: "",
            day_of_birth: null,
            place_of_birth: "",
            citizenship: ""
        }
    }

    prepareCreate() {
        this.baseClear()

        return this
    }

    prepareUpdate() {
        this.baseClear()

        return this
    }
}
